import { get } from "@insite/client-framework/Services/ApiService";

export interface POValidation {
    isDuplicate: boolean;
    isSuccess: boolean;
    message: string;
}

export const ValidatePONumber = async (poNumber: string) => {
    const response = await get<POValidation>(`/api/v2/cart/ValidatePONumber?poNumber=${poNumber}`);
    return response;
};